module.exports = __webpack_public_path__ + "static/media/babychakra.c3f1833b.png";